var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClassifierIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50mm",
    height: "50mm",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-53.576 -82.82)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.294,
    height: 20.577,
    x: 61.177,
    y: 86.569,
    ry: 4.251,
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.883,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.879 106.795v6.044s-6.108-.068-9.015.01c-4.691.126-7.488-.088-7.488 5.987m16.57-12.04v6.043s6.107-.068 9.014.01c4.691.126 7.488-.088 7.488 5.987",
    className: "classifierIcon_svg__UnoptimicedTransforms",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.01717
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.865 107.427v12.824",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.017
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.982,
    height: 9.982,
    x: 56.634,
    y: 119.806,
    ry: 0.796,
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.781,
    cy: 124.756,
    rx: 5.149,
    ry: 5.016,
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.413,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.463 119.25l-7.06 9.94 14.113-.017h.039c-5.38-7.505.022.007-7.092-9.922z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2.335,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.948 92.276H89.4M69.74 97.365h14.925M65.82 102.307h23.05",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1.965,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgClassifierIcon;